module.exports = __webpack_public_path__ + "static/media/Pause.72622a6a.svg";